<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      :label="fieldTitle"
      prop="flightFileList"
    >
      <el-row :gutter="24">
        <el-col :span="24" v-if="vbAttachments && vbAttachments.length">
          <div class="jobInfoAttachment style-fullWidth">
            <div
              v-for="vbAttachment in vbAttachments"
              v-bind:key="vbAttachment.id"
              class="file-uploaded input-none__border"
            >
              <div class="file clickable flex-row flex__between padding-0">
                <a
                  class="flex-row flex__left margin-left-10"
                  @click="downloadFile(vbAttachment)"
                >
                  <file-type-image
                    :fileExtention="vbAttachment.fileExtention"
                    :customClass="''"
                  />
                  <span class="">{{ vbAttachment.fileName }}</span>
                </a>
                <i
                  class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red"
                  @click="removeAttachment(vbAttachment)"
                ></i>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="style-fullWidth flex-row flex__left">
            <el-upload
              :action="uploadAttachmentURL"
              :on-success="onUploadSuccess"
              :data="uploadAdditionalData"
              :show-file-list="false"
              :headers="uploadAttachmentHeaders"
              :before-upload="
                file => validateUploadFile(file, validateUploadFileOptions)
              "
              :on-error="onUploadError"
              :on-change="() => (isUploadingFlag = true)"
              v-loading="isUploadingFlag && isUploading"
            >
              <el-button class="btnPlain margin-right-10">
                <i class="fas fa-cloud-upload-alt"></i>
                &nbsp;Tải file lên
              </el-button>
            </el-upload>
          </div>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
import FileTypeImage from "../../job/FileTypeImage";
import h from "../../../services/h";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import attachmentService from "../../../services/attachmentService";
import downloadService from "../../../services/downloadService";
import hcCaseFlightFileService from "../../../services/maybay/hcCaseFlightFileService";
import hcCaseFlightService from "../../../services/maybay/hcCaseFlightService";
import constants from "../../../constants";

export default {
  name: "hc-maybay-upload",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: {FileTypeImage},
  props: [
    "hcCaseFlightFileType",
    "hcCaseFlightId",
    "validateUploadFileOptions",
    "objectType"
  ],

  data() {
    return {
      isUploadingFlag: false,
      uploadAdditionalData: {objectType: null},
      vbAttachments: [],
      fieldTitle: null,
      hcCaseFlight: null,
      hcCaseFlightFiles: []
    };
  },

  watch: {
    hcCaseFlightId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    initUploadAdditionalData() {
      switch (this.hcCaseFlightFileType) {
        case constants.HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH:
          this.uploadAdditionalData.objectType =
            constants.ATTACHMENT_OBJECT_TYPE.TOTRINH_VEMAYBAY;
          break;
        case constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY:
          this.uploadAdditionalData.objectType =
            constants.ATTACHMENT_OBJECT_TYPE.VEMAYBAY;
          break;
      }
    },

    loadHcCaseFlight() {
      return hcCaseFlightService
        .findById(this.hcCaseFlightId)
        .then(response => (this.hcCaseFlight = response.data));
    },

    loadHcCaseFlightFiles() {
      return hcCaseFlightFileService
        .findAllByHcCaseMasterId(
          this.hcCaseFlight.caseMasterId,
          this.hcCaseFlightFileType
        )
        .then(response => (this.hcCaseFlightFiles = response.data));
    },

    loadVbAttachments() {
      return attachmentService
        .findAllByHcCaseFlightId(this.hcCaseFlightId, this.hcCaseFlightFileType)
        .then(response => (this.vbAttachments = response.data || []));
    },

    initFieldTitle() {
      this.fieldTitle = hanhChinhUtils.initHcCaseFlightFilesFieldTitle(
        this.hcCaseFlightFileType
      );
    },

    getData() {
      return h.collect(this.vbAttachments, item => {
        return {
          id: item.id,
          fileName: item.fileName,
          fileExtention: item.fileExtention
        };
      });
    },

    removeAttachment(vbAttachment) {
      this.vbAttachments.splice(this.vbAttachments.indexOf(vbAttachment), 1);
    },

    downloadFile(vbAttachment) {
      downloadService.downloadFileForHcCaseFlightFile(
        this.hcCaseFlightId,
        this.getHcCaseFlightFileId(vbAttachment),
        vbAttachment.id
      );
    },

    getHcCaseFlightFileId(vbAttachment) {
      let hcCaseFlightFile = h.find(
        this.hcCaseFlightFiles,
        item => item.attachmentId === vbAttachment.id
      );
      return hcCaseFlightFile ? hcCaseFlightFile.id : null;
    },

    async reloadData() {
      this.initFieldTitle();
      this.initUploadAdditionalData();
      if (this.hcCaseFlightId) {
        await this.loadHcCaseFlight();
        await this.loadHcCaseFlightFiles();
        await this.loadVbAttachments();
      }
    },

    onUploadSuccess(vbAttachment) {
      this.isUploading = false;
      this.vbAttachments.push(vbAttachment);
    }
  }
};
</script>

<style scoped>
.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-upload.vue